(function () {
  const LINE_COUNT = 3;

  function clampHeightPx(el) {
    const styles = window.getComputedStyle(el);
    let lh = parseFloat(styles.lineHeight);

    // if line-height is "normal" (often), estimate from font-size
    if (!lh || isNaN(lh)) {
      const fs = parseFloat(styles.fontSize) || 16;
      lh = fs * 1.35;
    }
    return Math.round(lh * LINE_COUNT);
  }

  function measure(wrapper) {
    const content = wrapper.querySelector("[data-readmore-content]");
    const toggle = wrapper.querySelector("[data-readmore-toggle]");
    if (!content || !toggle) return;

    // reset
    wrapper.classList.add("is-collapsed");
    toggle.textContent = "Read more";
    toggle.hidden = true;

    // measure after layout
    requestAnimationFrame(() => {
      const clamp = clampHeightPx(content);

      // force a real collapsed height so overflow can be measured
      content.style.maxHeight = clamp + "px";

      const overflow = content.scrollHeight > clamp + 2;
      toggle.hidden = !overflow;
    });
  }

  function init(wrapper) {
    const toggle = wrapper.querySelector("[data-readmore-toggle]");
    const content = wrapper.querySelector("[data-readmore-content]");
    if (!toggle || !content) return;

    const details = wrapper.closest("details");

    // measure when accordion opens (so scrollHeight is accurate)
    if (details) {
      details.addEventListener("toggle", () => {
        if (details.open) measure(wrapper);
      });

      // if already open
      if (details.open) measure(wrapper);
    } else {
      measure(wrapper);
    }

    toggle.addEventListener("click", () => {
      const collapsed = wrapper.classList.toggle("is-collapsed");

      if (collapsed) {
        toggle.textContent = "Read more";
        content.style.maxHeight = clampHeightPx(content) + "px";
      } else {
        toggle.textContent = "Read less";
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }

  function boot(root = document) {
    root.querySelectorAll("[data-readmore]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", () => boot());
  document.addEventListener("shopify:section:load", (e) => boot(e.target));
})();